import { useContext } from "react";

import { SlideDataContext } from "../contexts/slideDataContext";
import { SlideData } from "../interfaces/question.interface";

/**
 * Returns information on the amount of slides, answered/unanswered questions and current slide index
 *
 * @listens SlideDataContext
 * @return {{currentQuestionIndex: number, amountSlidesUncompleted: number, questionAmount: number}}
 */
const useQuizSlideInfo = (): {
  questionAmount: number;
  currentSegmentQuestionAmount: number;
  currentSegmentQuestions: Array<SlideData>;
  amountSlidesUncompleted: number;
  currentSlideIndex: number;
  slideAmount: number;
  questionsUncompleted: number;
  discussionAmount: number;
} => {
  const { quizSlideDataSequence } = useContext(SlideDataContext);

  let questionAmount = 0;
  let questionsUncompleted = 0;
  let currentSegmentQuestionAmount = 0;

  let discussionAmount = 0;

  const slideAmount = quizSlideDataSequence.length;
  let amountSlidesUncompleted: number = slideAmount;
  let currentSlideIndex = 0;

  const currentSegmentQuestions: Array<SlideData> = [];

  quizSlideDataSequence.forEach((slideData: SlideData) => {
    if (slideData.completed === true) {
      amountSlidesUncompleted -= 1;
      currentSlideIndex += 1;
    }

    if (slideData.question !== undefined) {
      questionAmount += 1;
      if (slideData.completed) {
        questionsUncompleted -= 1;
      }
    }

    if (slideData.discussion !== undefined) {
      discussionAmount += 1;
    }
  });

  for (let i = currentSlideIndex - 1; i >= 0; i--) {
    const slideData = quizSlideDataSequence[i];

    if (slideData.information?.type === "lecture") {
      break;
    }
    currentSegmentQuestions.push(slideData);
  }
  currentSegmentQuestions.reverse();
  currentSegmentQuestionAmount = currentSegmentQuestions.length;

  return {
    currentSlideIndex,
    amountSlidesUncompleted,
    questionAmount,
    slideAmount,
    currentSegmentQuestionAmount,
    questionsUncompleted,
    currentSegmentQuestions,
    discussionAmount,
  };
};

export default useQuizSlideInfo;
